export function addCurrent(categoryorganization) {
    return {
        type: 'ADD_CURRENT',
        categoryorganization,
    }
}
